import defineProperty from './defineProperty';


let model = {};

function loader(fn, args) {
  if (model[fn]) {
    return Promise.resolve(model[fn].apply(null, args));
  }
  return import(/* webpackChunkName: "core_utils_async" */ './~splitUploader').then(res => {
    model = res.default;
    return model[fn].apply(null, args);
  });
}

let res = {
  fileToHash(...args) {
    return loader('fileToHash', args);
  },
  createUploader(...args) {
    return loader('createUploader', args);
  },
  /**
   * 文件大小转换
   * @param size
   * @param isFill 是否填充零位
   * @returns {string}
   */
  fileSizeToString(size, isFill = false) {
    let f = _.round;
    if (size < 1048576) {
      return f(size / 1024, 2).toFixed(isFill ? 2 : 0) + "KB";
    }
    if (size < 1073741824) {
      return f(size / 1048576, 2).toFixed(isFill ? 2 : 0) + "MB";
    }
    return f(size / 1073741824, 2).toFixed(isFill ? 2 : 0) + "GB";
  }
};

defineProperty(res, "SplitUploader", {
  get() {
    return model.SplitUploader;
  }
});

export default res;
